import React from 'react';
import {Heading, RichContent, Text} from '../elements';

export const ServicesBulletedComponent = (props) => {
  const {heading, description, bulletListOne, bulletListTwo, bulletListThree} = props.content;
   return (
        <section className="col-12 kiwi-services--bulleted">
            <div className="container">
                <div className="row">
                    <div className="col-xs-12">
                        <Heading content={heading} size="h2" />
                    </div>
                    <div className="col-xs-12">
                        <RichContent dangerous={description} />
                    </div>
                </div>
                <div className="services--bulleted row">
                    <ul className="services--bulleted-list">
                        { bulletListOne && bulletListOne.map((elem, i) => {
                            return (
                                <li className="services--bulleted-list-item" key={i}>
                                    <Text content={elem.bulletPoint}/>
                                </li>
                            )})
                        }
                    </ul>

                    <ul className="services--bulleted-list">
                        { bulletListTwo && bulletListTwo.map((elem, i) => {
                            return (
                                <li className="services--bulleted-list-item" key={i}>
                                    <Text content={elem.bulletPoint}/>
                                </li>
                            )})
                        }
                    </ul>

                    <ul className="services--bulleted-list">
                        { bulletListThree && bulletListThree.map((elem, i) => {
                            return (
                                <li className="services--bulleted-list-item" key={i}>
                                    <Text content={elem.bulletPoint}/>
                                </li>
                            )})
                        }
                    </ul>
                </div>
            </div>
        </section>
   )
};



// WEBPACK FOOTER //
// src/client/components/common/CMS/components/ServicesBulletedComponent.js